import React, { useState } from "react";
import { getAPI, postAPI } from "../../helpers/httpHelper";
import { cognitoUserToken } from "../../helpers/userHelper";
import {
    ROW_COUNT,
    URL_SUPPORT,
    API_ROLES,
    API_ADMIN_PAGINACION
} from "../../helpers/variableHelper";
import AdminLista from "../administration/AdminLista";

const Roles  = () => {
    const userInfo = cognitoUserToken();
    const pageSize = ROW_COUNT;
    const [token, setToken] = useState("");
    const [listItems, setListItems] = useState<Array<any>>([]);
    const [page, setPage] = useState(1);
    const [pages, setPages] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    console.log(isLoading)


    React.useEffect(() => {
        (async () => {
            let token = await userInfo;
            setToken(token);
            let params = { PAGINA: 1, PAGINADO: pageSize, ORDENADOPOR: "ID", ORIENTACION: "DESC" }
            let list = (
                await getAPI(`${URL_SUPPORT}${API_ROLES}/getall`, { Authorization: `Bearer ${token}` }, params)
            ).result.data;

            let pags = (
                await getAPI(`${URL_SUPPORT}${API_ADMIN_PAGINACION}?ROWCOUNT=${pageSize}&SCHEMA=public&TABLENAME=ROLES`, { Authorization: `Bearer ${token}` })
            ).result.data.PAGINAS;

            setPages(pags);
            console.log(list);
            setListItems(list);
        })();
      setIsLoading(false);
    }, [token]);

    const filter = (filter: any, page: boolean = false, size = pageSize) => {
        console.log(filter);
        
        if (!filter) {
            filter = {};
        }

        filter.PAGINADO = size;
        if (filter.PAGINA === undefined) {
            filter.PAGINA = 1;
        }
        if (!page) {
            filter.PAGINA = 1;
        }
        
        setPage(filter.PAGINA);
        if (filter.ORDENADOPOR === undefined) {
            filter.ORDENADOPOR = "ID";
            filter.ORIENTACION = "DESC";
        }

        getAPI(`${URL_SUPPORT}${API_ROLES}/getall`, { Authorization: `Bearer ${token}` }, filter).then(result => {
            setListItems(result.result.data);
        }).catch(error => {

        });
    }

    const edit = (value: any, filters: any) => {
        console.log(value);

        delete value.FECHA_CREACION;
        delete value.TRANSACTION_ID;

        postAPI(`${URL_SUPPORT}${API_ROLES}`, value, { Authorization: `Bearer ${token}` }).then(result => {
            let data = result.result.data;
            console.log(data);
            filter(filters, value?.ID > 0);
        }).catch(error => {
            console.log(error);
        });
    }

    const paging = (page: any) => {
        console.log(page);
        setPage(page);
        let params = { PAGINA: page };
        filter(params, true);
    }

    return (
        <React.Fragment>
            <button data-testid="btntest" hidden={true} onClick={() => {
                paging(1)
            }}></button>
            <AdminLista reload={filter} callback={edit} data={listItems}
                tipo={"Roles"} filter={filter} pagination={{ pages: pages, page: page, paging: paging }} title="Roles"/>

                <button hidden={false} onClick={()=>{edit("",{})}}>Test</button>
        </React.Fragment>
    );

}

export default Roles;